import { combineReducers } from "redux";
import releasesReducer, * as releases from "./releases";

export default combineReducers({
  releases: releasesReducer,
});

export const getReleases = (state) => releases.get(state.releases);
